module.exports = __webpack_public_path__ + "static/media/logo-v3.0d75806d.png";